document.addEventListener('click',function(e){
  var dot=e.target.closest('.lv-dot'); if(!dot)return;
  e.preventDefault(); e.stopPropagation();
  var wrap=dot.parentElement, card=dot.closest('.card-wrapper');
  wrap.querySelectorAll('.lv-dot').forEach(function(d){d.classList.remove('on');});
  dot.classList.add('on');
  var vid=dot.getAttribute('data-var'), base=wrap.getAttribute('data-full');
  if(vid&&base){ card.querySelectorAll('a[href*="/products/"]').forEach(function(a){a.setAttribute('href',base+'?variant='+vid);}); }
  var img=dot.getAttribute('data-img');
  if(img){
    /* In der Kachel stecken zwei Bilder (ein verstecktes fuers Handy, eins sichtbar).
       Beide setzen, sonst wechselt nur das falsche. srcset muss weg, sonst gewinnt es gegen src.
       main-src mitziehen, weil global.js beim Verlassen der Kachel daraus wiederherstellt. */
    var link=card.querySelector('a.mi');
    if(link){ link.setAttribute('main-src', img); link.removeAttribute('data-src'); }
    var imgs=[].slice.call(card.querySelectorAll('.card__media img'));
    /* Erst umschalten, wenn das neue Bild wirklich da ist. Kein fixes Warten mehr:
       vorgeladene Bilder sind sofort dran, nicht vorgeladene blenden statt zu blitzen. */
    lvSwapImage(imgs, img);
  }
},true);

/* Farbbilder im Voraus holen, sobald die Maus ueber die Punktreihe faehrt oder
   die Kachel beruehrt wird. Dann ist der Klick selbst ohne Wartezeit. */
var lvPre={};
function lvPreload(row){
  row.querySelectorAll('.lv-dot[data-img]').forEach(function(d){
    var u=d.getAttribute('data-img');
    if(u&&!lvPre[u]){ lvPre[u]=new Image(); lvPre[u].src=u; }
  });
}
document.addEventListener('pointerover',function(e){
  var row=e.target.closest&&e.target.closest('.lv-dots');
  if(row&&!row.dataset.lvPre){ row.dataset.lvPre='1'; lvPreload(row); }
},true);
document.addEventListener('touchstart',function(e){
  var card=e.target.closest&&e.target.closest('.card-wrapper');
  if(card){ var row=card.querySelector('.lv-dots'); if(row&&!row.dataset.lvPre){ row.dataset.lvPre='1'; lvPreload(row); } }
},{passive:true,capture:true});

function lvSwapImage(imgs,url){
  function put(){
    imgs.forEach(function(m){
      m.removeAttribute('srcset'); m.removeAttribute('sizes');
      m.setAttribute('src', url); m.style.opacity='1';
    });
  }
  var pre=lvPre[url]||new Image();
  if(!lvPre[url]){ lvPre[url]=pre; pre.src=url; }
  if(pre.complete&&pre.naturalWidth){ put(); return; }
  imgs.forEach(function(m){ if(m.offsetParent!==null)m.style.opacity='.45'; });
  var done=false, fin=function(){ if(done)return; done=true; put(); };
  pre.addEventListener('load',fin); pre.addEventListener('error',fin);
  setTimeout(fin,900);
}

/* Kein Bildwechsel beim Ueberfahren auf der Kategorieseite.
   global.js tauscht bei mouseenter das srcset gegen das Ambiente-Bild aus a.mi[data-src].
   Ohne dieses Attribut greift der Tausch ins Leere, die Kachel behaelt ihr Hauptbild. */
function lvNoHoverSwap(){
  document.querySelectorAll('.product-grid a.mi[data-src]').forEach(function(a){ a.removeAttribute('data-src'); });
}

/* Texte kommen aus den Sprachdateien des Themes (Block #lv-i18n).
   Fehlt der Block, greifen die deutschen Vorgaben. */
/* Erst bei Bedarf auslesen: das Skript wird ohne defer eingebunden und laeuft
   damit, bevor der Block im Dokument steht. */
var lvTCache=null;
function LVT(){
  if(lvTCache)return lvTCache;
  var v={produkt_eins:'@@ Produkt',produkt_viele:'@@ Produkte',
         sortieren:'Sortieren',weiterlesen:'Weiterlesen'};
  var el=document.getElementById('lv-i18n');
  if(!el)return v;                       // noch nicht da, nicht zwischenspeichern
  try{ var d=JSON.parse(el.textContent); for(var k in d){ if(d[k])v[k]=d[k]; } }catch(e){}
  lvTCache=v; return v;
}
function lvAnzahl(n){
  var t=LVT();
  return (n===1?t.produkt_eins:t.produkt_viele).replace('@@',n);
}

/* ===== livevibe eigener Client-Filter ===== */
function lvInitFilter(){
  var root=document.querySelector('.lv-filters'); if(!root)return;
  if(root.dataset.lvInit)return; root.dataset.lvInit='1';
  var grid=document.querySelector('#product-grid, .product-grid'); if(!grid)return;
  var cards=[].slice.call(grid.querySelectorAll('.card-wrapper'));
  var state={avail:[],einsatz:[],groesse:[],vendor:[],farbe:[],pmin:null,pmax:null};

  function money(c){var w=Math.round(c/100);return 'CHF '+w.toLocaleString('de-CH').replace(/,/g,' ')+'.-';}

  // Preis-Slider
  var pr=root.querySelector('.lv-price');
  var PMIN=+pr.getAttribute('data-min'), PMAX=+pr.getAttribute('data-max');
  state.pmin=PMIN; state.pmax=PMAX;
  var fill=pr.querySelector('.lv-price-fill'), h1=pr.querySelector('.lv-price-h1'), h2=pr.querySelector('.lv-price-h2');
  var lmin=pr.querySelector('.lv-price-lmin'), lmax=pr.querySelector('.lv-price-lmax');
  function drawPrice(){
    var a=(state.pmin-PMIN)/(PMAX-PMIN)*100, b=(state.pmax-PMIN)/(PMAX-PMIN)*100;
    h1.style.left=a+'%'; h2.style.left=b+'%'; fill.style.left=a+'%'; fill.style.width=(b-a)+'%';
    lmin.textContent=money(state.pmin); lmax.textContent=money(state.pmax);
  }
  drawPrice();
  function dragHandle(handle,which){
    handle.addEventListener('pointerdown',function(e){
      e.preventDefault(); handle.setPointerCapture(e.pointerId);
      var track=pr.querySelector('.lv-price-track');
      function move(ev){
        var r=track.getBoundingClientRect();
        var pct=Math.min(1,Math.max(0,(ev.clientX-r.left)/r.width));
        var val=Math.round(PMIN+pct*(PMAX-PMIN));
        if(which===1){ state.pmin=Math.min(val,state.pmax); } else { state.pmax=Math.max(val,state.pmin); }
        drawPrice(); apply();
      }
      function up(ev){ handle.releasePointerCapture(e.pointerId); document.removeEventListener('pointermove',move); document.removeEventListener('pointerup',up); }
      document.addEventListener('pointermove',move); document.addEventListener('pointerup',up);
    });
  }
  dragHandle(h1,1); dragHandle(h2,2);

  /* Grosse Kategorien sind auf mehrere Seiten verteilt. Der Filter darf aber nur
     Treffer der ganzen Kategorie zeigen, nicht der zufaellig geladenen Seite.
     Darum holen wir die restlichen Seiten nach, sobald jemand den Filter anfasst. */
  var allLoaded=false, loading=false;
  function loadAll(done){
    if(allLoaded){ done&&done(); return; }
    if(loading){ return; }
    var max=1;
    [].slice.call(document.querySelectorAll('.pagination__list a')).forEach(function(a){
      var m=/[?&]page=(\d+)/.exec(a.getAttribute('href')||''); if(m)max=Math.max(max,+m[1]);
    });
    if(max<2){ allLoaded=true; done&&done(); return; }
    loading=true;
    var frags={}, pending=max-1;
    for(var p=2;p<=max;p++){
      (function(pg){
        var q=new URLSearchParams(location.search); q.set('page',pg); q.delete('r');
        fetch(location.pathname+'?'+q.toString(),{credentials:'same-origin'})
          .then(function(r){return r.text();})
          .then(function(html){
            var doc=new DOMParser().parseFromString(html,'text/html');
            frags[pg]=[].slice.call(doc.querySelectorAll('#product-grid > li'));
          })
          .catch(function(){ frags[pg]=[]; })
          .then(function(){
            if(--pending>0)return;
            for(var i=2;i<=max;i++){
              (frags[i]||[]).forEach(function(li){ grid.appendChild(document.importNode(li,true)); });
            }
            var pw=document.querySelector('.pagination-wrapper'); if(pw)pw.style.display='none';
            cards=[].slice.call(grid.querySelectorAll('.card-wrapper'));
            allLoaded=true; loading=false;
            rescale(); recount(); lvNoHoverSwap(); lvFitPrices(); done&&done();
          });
      })(p);
    }
  }

  /* Die Zahlen neben den Filtern kommen aus Liquid und kennen dort nur die erste Seite.
     Sobald alles geladen ist, zaehlen wir sie aus den Karten neu. */
  function recount(){
    [].slice.call(root.querySelectorAll('input[type=checkbox][data-f]')).forEach(function(cb){
      var f=cb.getAttribute('data-f'), v=cb.value, n=0;
      cards.forEach(function(c){
        if(f==='avail'){ if(c.getAttribute('data-available')===v)n++; }
        else if(f==='vendor'){ if((c.getAttribute('data-vendor')||'').toLowerCase()===v)n++; }
        else if(f==='einsatz'){ if((c.getAttribute('data-einsatz')||'').indexOf(v)>=0)n++; }
        else if(f==='groesse'){ if(c.getAttribute('data-groesse')===v)n++; }
      });
      var em=cb.parentElement.querySelector('em'); if(em)em.textContent=n;
    });
  }
  /* Preisspanne ebenfalls auf die ganze Kategorie ausweiten */
  function rescale(){
    var lo=Infinity, hi=0;
    cards.forEach(function(c){ var p=+c.getAttribute('data-price'); if(p<lo)lo=p; if(p>hi)hi=p; });
    if(!isFinite(lo)||hi<=lo)return;
    var wasFull=(state.pmin===PMIN&&state.pmax===PMAX);
    PMIN=lo; PMAX=hi;
    if(wasFull){ state.pmin=lo; state.pmax=hi; }
    else { state.pmin=Math.max(lo,state.pmin); state.pmax=Math.min(hi,state.pmax); }
    drawPrice();
  }

  function apply(){
    var shown=0;
    cards.forEach(function(c){
      var ok=true;
      if(state.avail.length && state.avail.indexOf(c.getAttribute('data-available'))<0) ok=false;
      if(ok&&state.vendor.length && state.vendor.indexOf((c.getAttribute('data-vendor')||'').toLowerCase())<0) ok=false;
      if(ok&&state.einsatz.length){ var e=(c.getAttribute('data-einsatz')||''); ok=state.einsatz.some(function(v){return e.indexOf(v)>=0;}); }
      if(ok&&state.groesse.length && state.groesse.indexOf(c.getAttribute('data-groesse'))<0) ok=false;
      if(ok&&state.farbe.length){ var f=(c.getAttribute('data-farben')||''); ok=state.farbe.some(function(v){return f.indexOf(v)>=0;}); }
      if(ok){ var p=+c.getAttribute('data-price'); if(p<state.pmin||p>state.pmax) ok=false; }
      var slot=c.closest('.grid__item')||c.parentElement||c;
      slot.style.display=ok?'':'none';
      c.style.display='';
      if(ok)shown++;
    });
    var txt=lvAnzahl(shown);
    var cnt=document.querySelector('.lv-result-count'); if(cnt)cnt.textContent=txt;
    var cntD=document.getElementById('ProductCountDesktop'); if(cntD)cntD.textContent=txt;
    var n=state.avail.length+state.einsatz.length+state.groesse.length+state.vendor.length+state.farbe.length
        +((state.pmin>PMIN||state.pmax<PMAX)?1:0);
    var badge=document.querySelector('.lv-mobfilter-n');
    if(badge){ badge.textContent=n; badge.hidden=(n===0); }
  }

  root.addEventListener('change',function(e){
    var cb=e.target.closest('input[type=checkbox][data-f]'); if(!cb)return;
    var f=cb.getAttribute('data-f'), v=cb.value;
    var arr=state[f]; var i=arr.indexOf(v);
    if(cb.checked){ if(i<0)arr.push(v); } else { if(i>=0)arr.splice(i,1); }
    apply(); loadAll(apply);
  });
  /* Restliche Seiten schon holen, sobald jemand die Filterspalte anfasst */
  root.addEventListener('pointerdown',function(){ loadAll(apply); },{once:false});
  root.addEventListener('click',function(e){
    var col=e.target.closest('.lv-fcol'); 
    if(col){ col.classList.toggle('on'); var v=col.getAttribute('data-val'); var i=state.farbe.indexOf(v);
      if(col.classList.contains('on')){ if(i<0)state.farbe.push(v); } else { if(i>=0)state.farbe.splice(i,1); } apply(); loadAll(apply); return; }
    if(e.target.closest('.lv-f-reset')){ 
      root.querySelectorAll('input[type=checkbox]').forEach(function(x){x.checked=false;});
      root.querySelectorAll('.lv-fcol.on').forEach(function(x){x.classList.remove('on');});
      state={avail:[],einsatz:[],groesse:[],vendor:[],farbe:[],pmin:PMIN,pmax:PMAX}; drawPrice(); apply(); return;
    }
    if(e.target.closest('.lv-f-close')||e.target.closest('.lv-f-foot .lv-apply')){ closeDrawer(); }
  });

  /* Sortierung: Dawns Auswahl steht nur auf dem Desktop, auf dem Handy kommt sie in die Schublade */
  var src=document.getElementById('SortBy');
  if(src && !root.querySelector('.lv-fsort')){
    var d=document.createElement('details'); d.className='lv-fg lv-fsort'; d.open=true;
    d.innerHTML='<summary></summary>';
    d.querySelector('summary').textContent=LVT().sortieren;
    var sel=document.createElement('select'); sel.className='lv-sortsel';
    sel.innerHTML=src.innerHTML; sel.value=src.value;
    sel.addEventListener('change',function(){
      var u=new URL(location.href); u.searchParams.set('sort_by',sel.value); location.href=u.toString();
    });
    d.appendChild(sel);
    root.insertBefore(d, root.querySelector('.lv-fg'));
  }

  /* Schublade oeffnen/schliessen inkl. abdunkelndem Hintergrund */
  var scrim=document.querySelector('.lv-fscrim');
  if(!scrim){ scrim=document.createElement('div'); scrim.className='lv-fscrim'; document.body.appendChild(scrim); }
  function closeDrawer(){ document.body.classList.remove('lv-filters-open'); }
  scrim.addEventListener('click',closeDrawer);
  document.addEventListener('keydown',function(e){ if(e.key==='Escape')closeDrawer(); });
  document.addEventListener('click',function(e){
    if(e.target.closest('.lv-mobfilter')){ document.body.classList.add('lv-filters-open'); loadAll(apply); }
  });

  apply();
}
/* Handy: aktueller und durchgestrichener Preis stehen auf einer Zeile. Bei fuenfstelligen
   Betraegen ("CHF 15 680.-" neben "CHF 22 404.-") reicht die Kachelbreite nicht, darum
   werden nur diese Zeilen so weit verkleinert, bis sie passen. Kurze Preise bleiben gross. */
function lvFitPrices(){
  var mobil = window.matchMedia('(max-width:749px)').matches;
  document.querySelectorAll('.product-grid .price').forEach(function(p){
    var teile=[].slice.call(p.querySelectorAll('.price-item, s, del')).filter(function(e){
      return e.offsetParent!==null;
    });
    teile.forEach(function(e){ e.style.removeProperty('font-size'); });
    if(!mobil || teile.length<2) return;
    var box=p.parentElement; if(!box) return;
    var platz=box.clientWidth - 2;
    var luecke=6*(teile.length-1);
    var noetig=teile.reduce(function(a,e){ return a+e.getBoundingClientRect().width; },0)+luecke;
    if(noetig<=platz) return;
    var f=Math.max(0.68,(platz-luecke)/(noetig-luecke));
    teile.forEach(function(e){
      var akt=parseFloat(getComputedStyle(e).fontSize);
      e.style.setProperty('font-size',(akt*f).toFixed(2)+'px','important');
    });
  });
}
var lvFitT;
window.addEventListener('resize',function(){ clearTimeout(lvFitT); lvFitT=setTimeout(lvFitPrices,150); });

function lvBoot(){ lvNoHoverSwap(); lvInitFilter(); lvFitPrices(); }
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',lvBoot);}else{lvBoot();}
window.addEventListener('load',lvBoot);

/* SEO-Text: Weiterlesen-Klappe */
(function(){
  function initSeo(){
    var col=document.querySelector('.lv-foot-seo'); if(!col||col.dataset.lvSeo)return;
    var body=col.querySelector('.lv-seo-body'); if(!body)return; col.dataset.lvSeo='1';
    if(body.scrollHeight>460){
      body.classList.add('lv-seo-clamp');
      var btn=document.createElement('button'); btn.type='button'; btn.className='lv-seo-more';
      btn.textContent=LVT().weiterlesen;
      col.appendChild(btn);
      btn.addEventListener('click',function(){ body.classList.remove('lv-seo-clamp'); btn.remove(); });
    }
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initSeo);}else{initSeo();}
  window.addEventListener('load',initSeo);
})();